import { Routes, Route } from "react-router-dom";
import NoteList from "./NoteList";
import NoteForm from "./NoteForm";


export default function Notes(){
return (
<Routes>
<Route path="/" element={<NoteList/>} />
<Route path="new" element={<NoteForm/>} />
</Routes>
);
}